import Vue from "vue";
import Router from "vue-router";

import Layout from "@/components/Layout/Layout";
import Login from "@/pages/Login/Login";
import inicio from "@/pages/Login/Inicio";
import documentacion from "@/pages/Login/documentacion.vue";
import ErrorPage from "@/pages/Error/Error";
import Error from "@/pages/Error/Error";

import Dashboard from "@/pages/Dashboard/Dashboard";
import Configuracion from "@/pages/Configuracion/Configuracion";

import EmpresaLista from "@/pages/Empresa/EmpresaLista";
import EmpresaNuevo from "@/pages/Empresa/EmpresaNuevo";
import EmpresaEditar from "@/pages/Empresa/EmpresaEditar";
import EmpresaDetalle from "@/pages/Empresa/EmpresaDetalle";
import EmpresaNuevoServicio from "@/pages/Empresa/EmpresaNuevoServicio";
import EmpresaVencimientoEditar from "@/pages/Empresa/EmpresaVencimientoEditar";
import ServicioVencimiento from "@/pages/Empresa/VencimientoLista";

import LicenciasLista from "@/pages/Licencias/LicenciasLista";
import VersionesLista from "@/pages/Versiones/VersionesLista";

import CambioLista from "@/pages/Cambio/CambioLista";
import CambioNuevo from "@/pages/Cambio/CambioNuevo";

import ServicioLista from "@/pages/Servicio/ServicioLista";

import registro from "@/pages/Usuario/registro";
import ListaUsuarios from "@/pages/Usuario/ListaUsuarios";
import UsuarioDetalle from "@/pages/Usuario/DetalleUsuario";

import validarcorreo from "@/pages/Login/validarcorreo";

import ListaPlanes from "@/pages/Plan/PlanesLista";
import PlanesAgregar from "@/pages/Plan/PlanesNuevo";
import SSCOIndex from "@/pages/SSCO/Index";
import BuzonSunatView from "@/pages/Buzon/BuzonSunatView";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/buzon-sunat",
      name: "BuzonSunatDirecto",
      component: BuzonSunatView,
    },
    {
      path: "/",
      name: "inicio",
      component: inicio,
    },
    {
      path: "/registro",
      name: "registro",
      component: registro,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/confirmar/:codigo",
      name: "confirmar",
      component: validarcorreo,
    },
    {
      path: "/documentacion",
      name: "documentacion",
      component: documentacion,
    },
    {
      path: "/error",
      name: "Error",
      component: ErrorPage,
    },
    {
      path: "/aveo",
      name: "Layout",
      component: Layout,
      children: [
        {
          path: "Dashboard",
          name: "Dashboard",
          component: Dashboard,
        },
        {
          path: "ListaUsuarios",
          name: "ListaUsuarios",
          component: ListaUsuarios,
        },
        {
          path: "Usuario/UsuarioDetalle/:id",
          name: "UsuarioDetalle",
          component: UsuarioDetalle,
        },
        {
          path: "Empresa/Lista",
          name: "EmpresaLista",
          component: EmpresaLista,
        },
        {
          path: "Empresa/Nuevo",
          name: "EmpresaNuevo",
          component: EmpresaNuevo,
        },
        {
          path: "Empresa/Nuevo/:ruc",
          name: "EmpresaEditar",
          component: EmpresaEditar,
        },
        {
          path: "Empresa/Detalle/:ruc",
          name: "EmpresaDetalle",
          component: EmpresaDetalle,
        },
        {
          path: "Empresa/AgregarServicio",
          name: "EmpresaAgregarServicio",
          component: EmpresaNuevoServicio,
        },
        {
          path: "Empresa/VencimientoEditar",
          name: "EmpresaVencimientoEditar",
          component: EmpresaVencimientoEditar,
        },
        {
          path: "Empresa/VencimientoLista",
          name: "VencimientoLista",
          component: ServicioVencimiento,
        },
        {
          path: "Licencia/Lista",
          name: "LicenciasLista",
          component: LicenciasLista,
        },
        {
          path: "Versiones/Lista",
          name: "VersionesLista",
          component: VersionesLista,
        },
        {
          path: "Servicio/Lista",
          name: "ServicioLista",
          component: ServicioLista,
        },
        {
          path: "Cambio/Lista",
          name: "CambioLista",
          component: CambioLista,
        },
        {
          path: "Cambio/Nuevo",
          name: "CambioNuevo",
          component: CambioNuevo,
        },
        {
          path: "configuracion",
          name: "Configuracion",
          component: Configuracion,
        },
        {
          path: "Plan/ListaPlanes",
          name: "ListaPlanes",
          component: ListaPlanes,
        },
        {
          path: "Plan/PlanesAgregar",
          name: "PlanesAgregar",
          component: PlanesAgregar,
        },
        {
          path: "Plan/PlanesEditar/:id",
          name: "PlanesEditar",
          component: PlanesAgregar,
        },
        {
          path: "SSCO",
          name: "SSCO",
          component: SSCOIndex,
        },
        {
          path: "BuzonSunat",
          name: "BuzonSunat",
          component: BuzonSunatView,
        },
        {
          path: "*",
          name: "error",
          component: Error,
        },
      ],
    },
  ],
});
